import moment from 'moment'
export const EN_DATE_FORMAT_FULL = 'YYYY/MM/DD ddd HH:mm:ss'
export const JpnCalenderLookup = [
  { era: 'Reiwa', start: '2019/5/1' },
  { era: 'Heisei', start: '1989/1/8' },
  { era: 'Showa', start: '1926/12/25' },
  { era: 'Taisho', start: '1912/7/30' },
  { era: 'Meiji', start: '1868/1/25' }
]

export const maskZipCode = (zipCodeInput: string): string => {
  let zipCode = zipCodeInput
  const zipCodeLength = zipCodeInput.length
  const reg = /^\d+$/
  if (zipCodeLength < 9) {
      if (zipCodeLength === 4 && reg.test(zipCodeInput)) {
          zipCode = zipCodeInput.substring(0, 3) + '-' + zipCodeInput[zipCodeLength - 1]
      }
  } else {
      zipCode = zipCodeInput.substring(0, 8)
  }
  return zipCode
}

/**
 * Japanese area codes lists .
 * these area codes are 2019.5.22 version
 *  from https://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/shigai_list.html .
 */
const numberOne = '3_4_6'
const numberTwo = '11_15_17_18_19_22_23_24_25_26_27_28_29_42_43_44_45_46_47_48_49_52_53_54_55_58_59_' +
                  '72_73_75_76_77_78_79_82_83_84_86_87_88_89_92_93_95_96_97_98_99'
const numberThree = '123_124_125_126_133_134_135_136_137_138_139_142_143_144_145_146_152_153_154_155_' +
  '156_157_158_162_163_164_165_166_167_172_173_174_175_176_178_179_182_183_184_185_' +
  '186_187_191_192_193_194_195_197_198_220_223_224_225_226_228_229_233_234_235_237_' +
  '238_240_241_242_243_244_246_247_248_250_254_255_256_257_258_259_260_261_263_264_' +
  '265_266_267_268_269_270_274_276_277_278_279_280_282_283_284_285_287_288_289_291_' +
  '293_294_295_296_297_299_422_428_436_438_439_460_463_465_466_467_470_475_476_478_' +
  '479_480_493_494_495_531_532_533_536_537_538_539_544_545_547_548_550_551_553_554_' +
  '555_556_557_558_561_562_563_564_565_566_567_568_569_572_573_574_575_576_577_578_' +
  '581_584_585_586_587_594_595_596_597_598_599_721_725_735_736_737_738_739_740_742_' +
  '743_744_745_746_747_748_749_761_763_765_766_767_768_770_771_772_773_774_776_778_' +
  '779_790_791_794_795_796_797_798_799_820_823_824_826_827_829_833_834_835_836_837_' +
  '838_845_846_847_848_852_853_854_855_856_857_858_859_863_865_866_867_868_869_875_' +
  '877_879_880_883_884_885_887_889_892_893_894_895_896_897_898_920_930_940_942_943_' +
  '944_946_947_948_949_950_952_954_955_956_957_959_964_965_966_967_968_969_972_973_' +
  '974_977_978_979_980_982_983_984_985_986_987_993_994_995_996_997'
const numberFour = '1267_1372_1374_1377_1392_1397_1398_1456_1457_1466_1547_1558_1564_1586_1587_1632_' +
                    '1634_1635_1648_1654_1655_1656_1658_4992_4994_4996_4998_5769_5979_7468_8387_8388_' +
                    '8396_8477_8512_8514_9496_9802_9912_9913_9969'
const freeNumber = '120_990_570'
const ibNumber = '800'
const mobileNumber = '20_50_70_80_90'
export const areaCodeList = [
  { id: 'one', number: numberOne },
  { id: 'two', number: numberTwo },
  { id: 'three', number: numberThree },
  { id: 'four', number: numberFour },
  { id: 'free', number: freeNumber },
  { id: 'ib', number: ibNumber },
  { id: 'mobile', number: mobileNumber }
]
export const getSendEmailDateAndTime = (): string => {
  return moment().format(EN_DATE_FORMAT_FULL)
}
export const formatEmailSubjectDate = (): string => {
  return moment().format('YYYYMMDD')
}
